const STORAGE_KEY = "anytime-consultations/answered_search";

export function persistSearchKeys(keys: object | null): void {
  if (keys === null) {
    sessionStorage.removeItem(STORAGE_KEY);
    return;
  }
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(keys));
}

export function readPersistedSearchKeys(): object | null {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
}
